import { render } from "./recruitment.vue?vue&type=template&id=2886eb3c&scoped=true"
import script from "./recruitment.vue?vue&type=script&lang=js"
export * from "./recruitment.vue?vue&type=script&lang=js"

import "./recruitment.vue?vue&type=style&index=0&id=2886eb3c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2886eb3c"]])

export default __exports__